/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Criteria } from './Criteria';
import {
    CriteriaFromJSON,
    CriteriaFromJSONTyped,
    CriteriaToJSON,
    CriteriaToJSONTyped,
} from './Criteria';

/**
 * 
 * @export
 * @interface CriteriaTargetGroup
 */
export interface CriteriaTargetGroup {
    /**
     * 
     */
    criteria: Criteria;
    /**
     * 
     */
    facility_ids: Array<string>;
    /**
     * 
     */
    facility_system_tags: Array<string>;
    /**
     * 
     */
    facility_custom_tag_ids: Array<string>;
}

/**
 * Check if a given object implements the CriteriaTargetGroup interface.
 */
export function instanceOfCriteriaTargetGroup(value: object): value is CriteriaTargetGroup {
    if (!('criteria' in value) || value['criteria'] === undefined) return false;
    if (!('facility_ids' in value) || value['facility_ids'] === undefined) return false;
    if (!('facility_system_tags' in value) || value['facility_system_tags'] === undefined) return false;
    if (!('facility_custom_tag_ids' in value) || value['facility_custom_tag_ids'] === undefined) return false;
    return true;
}

export function CriteriaTargetGroupFromJSON(json: any): CriteriaTargetGroup {
    return CriteriaTargetGroupFromJSONTyped(json, false);
}

export function CriteriaTargetGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): CriteriaTargetGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'criteria': CriteriaFromJSON(json['criteria']),
        'facility_ids': json['facility_ids'],
        'facility_system_tags': json['facility_system_tags'],
        'facility_custom_tag_ids': json['facility_custom_tag_ids'],
    };
}

export function CriteriaTargetGroupToJSON(json: any): CriteriaTargetGroup {
    return CriteriaTargetGroupToJSONTyped(json, false);
}

export function CriteriaTargetGroupToJSONTyped(value?: CriteriaTargetGroup | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'criteria': CriteriaToJSON(value['criteria']),
        'facility_ids': value['facility_ids'],
        'facility_system_tags': value['facility_system_tags'],
        'facility_custom_tag_ids': value['facility_custom_tag_ids'],
    };
}

